export default "__VITE_ASSET__CNXOF5pU__"